/* eslint-disable no-unused-vars */
import React, { memo } from 'react';

import Load from 'components/Load/Load';
import Consult from './Consult';
import * as S from './styled';

function OptionsMeasure({ type = '', listDataUsers, loadingRead }) {
	return (
		<S.containerOption>
			{loadingRead ? <Load /> : <Consult typeMeasureMenu={type} listDataUsers={listDataUsers} />}
		</S.containerOption>
	);
}

export default memo(OptionsMeasure);
